
import React from 'react';
import { useParams } from 'react-router-dom';
import exact from 'prop-types-exact';
import NewsSingle from '../../components/news/containers/NewsSingleContainer';
import { fetchDataSingleNewsIfNeeded } from '../../components/news/actions/NewsActions';

const NoticiaInterna = () => {
    const { slug } = useParams();

    return (
        <div className="pageWrapper ">
            <NewsSingle slug={slug} />
        </div>
    );
};

// Note: Not fetching the most read news here, as we only need the data on desktop, not on mobile
// store.dispatch(fetchDataNewsMostReadIfNeeded())
NoticiaInterna.fetchData = (store, match) => store.dispatch(fetchDataSingleNewsIfNeeded(match.params.slug));


NoticiaInterna.propTypes = exact({});

export default NoticiaInterna;
